import { ServiceMaintenanceStatusCodes } from '@enums/httpStatusCodes';
import { NetworkErrorCode } from '@enums/networkErrorCodes';
import { NetworkErrorMessage } from '@enums/networkErrorMessages';

const networkErrorCodes = new Set(Object.values(NetworkErrorCode));
const networkErrorMessages = new Set(Object.values(NetworkErrorMessage));
const serviceMaintenanceStatusCodes = new Set(
  Object.values(ServiceMaintenanceStatusCodes)
);

let globalUnhandledRejectionHandler: (() => void) | null = null;

export const setGlobalUnhandledRejectionHandler = (handler: () => void) => {
  globalUnhandledRejectionHandler = handler;
};

const shouldRedirectToServiceMaintenance = (error: any): boolean => {
  const status = error.response?.status;
  const errorCode = error.code;
  const errorMessage = error.message?.toLowerCase() || '';

  const isHttpError = serviceMaintenanceStatusCodes.has(status);

  const isNetworkError =
    !error.response &&
    (networkErrorCodes.has(errorCode) ||
      Array.from(networkErrorMessages).some(msg => errorMessage.includes(msg)));

  return isHttpError || isNetworkError;
};

export const setupGlobalErrorHandlers = () => {
  window.addEventListener('unhandledrejection', event => {
    console.error('Unhandled promise rejection:', event.reason);

    if (
      shouldRedirectToServiceMaintenance(event.reason) &&
      globalUnhandledRejectionHandler
    ) {
      event.preventDefault();
      globalUnhandledRejectionHandler();
    }
  });

  window.addEventListener('error', event => {
    console.error('Global error:', event.error);
    if (globalUnhandledRejectionHandler) {
      const errorMessage = event.error?.message || event.message || '';
      if (
        Array.from(networkErrorMessages).some(msg => errorMessage.includes(msg))
      ) {
        globalUnhandledRejectionHandler();
      }
    }
  });
};

export default {
  setGlobalUnhandledRejectionHandler,
  setupGlobalErrorHandlers,
};
